<div class="jd-page">
  <!-- Back + header -->
  <button class="jd-back" (click)="navigateBack()">
    <emerald-icon>arrow_back</emerald-icon> Back
  </button>

  <div class="jd-head">
    <div class="jd-head-main">
      <h2 class="jd-title">{{ jobTitle }}</h2>
      <div class="jd-meta">
        <span class="jd-meta-item"><span class="k">Project</span><span class="v">{{ projectName || '—' }}</span></span>
        <span class="jd-meta-item"><span class="k">Hiring Manager</span><span class="v">{{ hiringManagerName || '—' }}</span></span>
        <span class="jd-meta-item"><span class="k">Primary Skills</span><span class="v">{{ primarySkills || '—' }}</span></span>
        <span class="jd-meta-item"><span class="k">Candidates Submitted</span><span class="v">{{ totalCount }}</span></span>
      </div>
    </div>
    <button class="jd-jdbtn" *ngIf="jobDescriptionFilePath" (click)="jobDescription()">
      <emerald-icon>download</emerald-icon> Job Description
    </button>
  </div>

  <div class="op-card">
    <!-- Toolbar -->
    <div class="op-toolbar">
      <div class="op-search">
        <emerald-icon class="op-search-ic">search</emerald-icon>
        <input type="text" [value]="filterValue" (keyup)="searchItem($event)" placeholder="Search candidates…" aria-label="Search candidates" />
        <button *ngIf="filterValue?.length && filterValue.length > 0" class="op-search-clear" (click)="clearInput()" aria-label="Clear search">✕</button>
      </div>

      <div class="op-chips" *ngIf="activeFilterCount">
        <span class="op-chip" *ngIf="activeFilters.status">Status: <b>{{ activeFilters.status }}</b></span>
        <span class="op-chip" *ngIf="activeFilters.location">Location: <b>{{ activeFilters.location }}</b></span>
      </div>

      <div class="op-spacer"></div>

      <div class="op-filter-slot">
        <button class="op-filterbtn" (click)="toggleFilterPanel()">
          <emerald-icon>filter_list</emerald-icon> Filters
          <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
        </button>
        <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
        <div class="op-filter-panel" *ngIf="showFilterPanel">
          <div class="op-fp-head">Filter candidates</div>
          <div class="op-fp-row">
            <label class="op-fp-label">Status</label>
            <select class="op-fp-field" [(ngModel)]="filterDraft.status">
              <option value="">All</option>
              <option *ngFor="let v of facetStatus" [value]="v">{{ v }}</option>
            </select>
          </div>
          <div class="op-fp-row">
            <label class="op-fp-label">Location</label>
            <select class="op-fp-field" [(ngModel)]="filterDraft.location">
              <option value="">All</option>
              <option *ngFor="let v of facetLocation" [value]="v">{{ v }}</option>
            </select>
          </div>
          <div class="op-fp-actions">
            <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
            <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="op-table-wrap" *ngIf="displayData.length > 0; else noData">
      <table class="op-table">
        <colgroup>
          <col style="width:20%" /><col style="width:8%" /><col style="width:14%" />
          <col style="width:12%" /><col style="width:12%" /><col style="width:12%" /><col style="width:22%" />
        </colgroup>
        <thead>
          <tr>
            <th class="sortable" (click)="sortBy('candidateName')" (mouseenter)="showTip($event, 'Name')" (mouseleave)="hideTip()">Name <span class="op-sort" [ngClass]="sortIndicator('candidateName')"></span></th>
            <th class="sortable" (click)="sortBy('yearsOfExperience')" (mouseenter)="showTip($event, 'Experience')" (mouseleave)="hideTip()">Exp <span class="op-sort" [ngClass]="sortIndicator('yearsOfExperience')"></span></th>
            <th class="sortable" (click)="sortBy('location')" (mouseenter)="showTip($event, 'Location')" (mouseleave)="hideTip()">Location <span class="op-sort" [ngClass]="sortIndicator('location')"></span></th>
            <th class="sortable" (click)="sortBy('createdDate')" (mouseenter)="showTip($event, 'Date applied')" (mouseleave)="hideTip()">Applied <span class="op-sort" [ngClass]="sortIndicator('createdDate')"></span></th>
            <th class="sortable" (click)="sortBy('earliestAvailability')" (mouseenter)="showTip($event, 'Available by')" (mouseleave)="hideTip()">Available <span class="op-sort" [ngClass]="sortIndicator('earliestAvailability')"></span></th>
            <th class="sortable" (click)="sortBy('status')" (mouseenter)="showTip($event, 'Status')" (mouseleave)="hideTip()">Status <span class="op-sort" [ngClass]="sortIndicator('status')"></span></th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of displayData; trackBy: trackByIndex">
            <td (mouseenter)="showTip($event, row.candidateName)" (mouseleave)="hideTip()">
              <div class="cd-name">
                <span class="op-tip-txt cd-name-main">{{ row.candidateName }}</span>
                <span class="cd-name-sub muted">{{ row.emailId }}</span>
              </div>
            </td>
            <td class="mono">{{ $any(row).yearsOfExperience ?? row.experience }}</td>
            <td (mouseenter)="showTip($event, rowLocation(row))" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ rowLocation(row) }}</span></td>
            <td class="mono muted">{{ row.createdDate | date: dateFormat.Month }}</td>
            <td class="mono muted">{{ row.earliestAvailability | date: dateFormat.Month }}</td>
            <td><span class="op-pill" [ngClass]="statusClass(row.status)"><span class="dot"></span>{{ row.status }}</span></td>
            <td class="op-cell-actions">
              <div class="op-actions">
                <button *ngIf="row.resumePath" class="op-iconbtn" title="Download resume" (click)="downloadFile(row.resumePath, row.candidateName, 'resume')"><emerald-icon>download</emerald-icon></button>
                <button *ngIf="row.additionalDocumentsPath" class="op-iconbtn" title="Download screening feedback" (click)="downloadFile(row.additionalDocumentsPath, row.candidateName, 'attachments')"><emerald-icon>description</emerald-icon></button>
                <button class="op-rowbtn" [disabled]="isDisabled(row.status)" (click)="getCandidateInfor(row.candidateId)"><emerald-icon>edit</emerald-icon> Edit</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #noData>
      <section class="op-empty" aria-label="Records section">
        <h2 *ngIf="isDataLoaded" class="op-empty-title">{{ errorMsg }}</h2>
        <img [src]="imageSrc" alt="No records illustration" class="op-empty-img" />
      </section>
    </ng-template>

    <!-- Pagination footer -->
    <div class="op-tfoot" *ngIf="displayData.length > 0">
      <div class="op-info">Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ filteredCount }}</b> candidates</div>
      <div class="op-pager">
        <button class="pg" (click)="prevPage()" [disabled]="currentPage === 1" aria-label="Previous page">‹</button>
        <button *ngFor="let p of pageWindow; trackBy: trackByIndex" class="pg" [class.on]="p === currentPage" [disabled]="p === -1" (click)="goToPage(p)">{{ p === -1 ? '…' : p }}</button>
        <button class="pg" (click)="nextPage()" [disabled]="currentPage >= totalPages" aria-label="Next page">›</button>
      </div>
      <div class="op-psize">
        <span>Rows</span>
        <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Edit / delete flows (unchanged) -->
  <app-add-candidate
    (updateState)="resetActions($event)"
    [edit]="edit"
    (candidateUpdated)="receiveData($event, candidateId)"
    [fieldsVisibility]="fieldsVisibility"
    [candidateId]="candidateId"
    [jobLocation]="location"
  ></app-add-candidate>
  <app-delete-candidate
    [delete]="delete"
    (updateState)="resetActions($event)"
    (candidateDeleted)="deleteCandidate($event)"
    [candidateId]="candidateId"
    [candidateName]="candidateName"
    [fieldsVisibility]="fieldsVisibility"
  ></app-delete-candidate>

  <!-- Fixed hover tooltip -->
  <div class="op-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
    {{ hoverTip.text }}
  </div>
</div>
